import { useEffect } from "react";

/**
 * Escape — выход из сессии рисования (передаётся колбэк, который сам решает про диалог).
 * Не срабатывает при фокусе в input/textarea, чтобы не ломать ввод и стандартное поведение полей.
 */
export function useDrawingSessionKeyboard(
  enabled: boolean,
  onEscape: () => void,
): void {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      const t = document.activeElement;
      if (t && (t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT")) {
        return;
      }
      e.preventDefault();
      onEscape();
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, [enabled, onEscape]);
}
